import {
  AUTH_LOGIN_FAILURE,
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SUCCESS,
  AUTH_REGISTER_FAILURE,
  AUTH_REGISTER_REQUEST,
  AUTH_REGISTER_SUCCESS,
  AUTH_LOGOUT
} from "./actionTypes";
import axios from "axios";

export const authRegister = (data) => async (dispatch) => {
  try {
    dispatch({ type: AUTH_REGISTER_REQUEST });

    const res = await axios.post(
      "https://bnmn-re8p.onrender.com/users/signup",
      data
    );
    //console.log('res: ', res);

    dispatch({
      type: AUTH_REGISTER_SUCCESS,
      payload: {
        message: 'user created sucessfully',
        data:res.data
      },
    });
  } catch (error) {
    dispatch({
      type: AUTH_REGISTER_FAILURE,
      payload: {
        message: error.response.data.message,
      },
    });
  }
};

export const authLogin = (data) => async (dispatch) => {
//   console.log("data: ", data);
  try {
    dispatch({ type: AUTH_LOGIN_REQUEST });

    const res = await axios.post(
      "https://bnmn-re8p.onrender.com/users/login",
      data
    );
     console.log("res: ", res);

    dispatch({
      type: AUTH_LOGIN_SUCCESS,
      payload: {
        token: res.data.token,
        message:res.data.message,
        user: res.data.user,
      },
    });
  } catch (error) {
    // console.log("error: ", error);

    dispatch({
      type: AUTH_LOGIN_FAILURE,
      payload: {
        message: 'user with this mail does not exist',
      },
    });
  }
};

export const signout = () => {
  return {
    type: AUTH_LOGOUT,
  };
};
